// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1M55a","bigColWidth":"Table_bigColWidth__2VFqL","biggerColWidth":"Table_biggerColWidth__2TeKr","row":"Table_row__1HHk2","col":"Table_col__1BPLb"};